import axios from "./axiosInstance";

const brandAPI = {
  getDetails: (params) => axios.get("brands/", {params}),

  addDetails: (payload) => axios.post("brands/", payload),

  updateDetails: (id, payload) => axios.put(`brands/${id}`, payload),

  getSingleDetails: (id) => axios.get(`brands/${id}`),

  updateStatus: (id, payload) => axios.patch(`brands/${id}/visibility`, payload),

  updateActiveStatus: (id) => axios.patch(`brands/${id}/status`),

  updateOrder: (payload) => axios.put("brands/reorder", payload),

  deleteItem: (id) => axios.delete(`brands/${id}`),

  getListforDropdown: () => axios.get("brands/dropdowns"),
};

export default brandAPI;
